import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const appInsights = new ApplicationInsights({
  config: {
    connectionString:
      "InstrumentationKey=a08a2025-eef3-483e-bf8b-34bfb4346a30;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/;ApplicationId=ca3cdfd1-ae29-416a-9924-3d70456dc81b",
    enableAutoRouteTracking: true, // Automatically tracks SPA route changes
  },
});

appInsights.loadAppInsights();

/**
 * ✅ Sets global user context (username + coachId)
 * Adds telemetry initializer that enriches all telemetry items with:
 *  - username
 *  - coachId
 *  - timestamp
 */
export const setAppInsightsUserContext = (username, coachId) => {
  if (username || coachId) {
    try {
      // Set authenticated user globally
      appInsights.setAuthenticatedUserContext(username || "", coachId || "");

      // Add global telemetry initializer once
      appInsights.addTelemetryInitializer((envelope) => {
        const baseData =
          envelope.data?.baseData ||
          envelope.baseData ||
          (envelope.data = { baseData: {} });

        if (!baseData.properties) baseData.properties = {};

        baseData.properties.username = username || "AnonymousUser";
        baseData.properties.coachId = coachId || "UnknownCoach";
        baseData.properties.timestamp = new Date().toLocaleString();
      });

      console.log("✅ App Insights user context set:", {
        username,
        coachId,
      });
    } catch (error) {
      console.error("❌ Failed to set App Insights user context:", error);
    }
  }
};

// Default page view (optional)
appInsights.trackPageView({ name: "Login Page" });

export default appInsights;
